import { useQuery } from '@tanstack/react-query'

import { getBulkTransactionStatus } from '@pepper/utils/src/api/assignments/assignments'
import { getBulkWorkflowTransactionStatus } from '@pepper/utils/src/api/misc/misc'

const shouldPing = (data: BulkTransactionResponse | undefined): boolean => {
  if (!data) return false
  const { transaction_data = [] } = data
  return transaction_data.some(progress => progress.status === 'in-progress')
}

export const useBulkInProgressStatus = (
  id: string,
  isBulkWorkflow?: boolean
) => {
  const pollingTime = 2000
  return useQuery<BulkTransactionResponse>({
    queryKey: ['bulkStatus', id],
    queryFn: async () => {
      let response
      if (isBulkWorkflow) {
        response = await getBulkWorkflowTransactionStatus(id)
      } else {
        response = await getBulkTransactionStatus(id)
      }
      if (response.status === 'error') throw new Error(response.error)
      return response.data
    },
    refetchInterval: data => (shouldPing(data) ? pollingTime : false),
    retry: false
  })
}
